import { IconFunctionalHouse16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './NearbyNewbuildingsLink.css';
import { Link } from '../Link';

export interface INearbyNewbuildingsLinkProps {
  url: string;
  onClick(): void;
}

export const NearbyNewbuildingsLink: React.FC<React.PropsWithChildren<INearbyNewbuildingsLinkProps>> = ({
  url,
  onClick,
}) => {
  return (
    <Link className={styles['item']} url={url} target="blank" onClick={onClick}>
      <div className={styles['logo']}>
        <IconFunctionalHouse16 color="current_color" />
      </div>
      <span className={styles['label']}>Другие ЖК рядом</span>
    </Link>
  );
};
